import React, {useEffect} from 'react'
import apiClient from '../http-common';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import {setWithdrawals, setCards, setLoans, setShareholders, setWallets, setInvestments, setDepayTransactions} from './hitorySlice';

export const AccountHistory = () => {

  const dispatch = useDispatch();

    const { isLoading: isLoadingHistory, refetch: getHistory } = useQuery(
        "charts-analysis",
        async () => {
          return await apiClient.get("/api/history");
        },
        {
          enabled: true,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                dispatch(setWithdrawals(res.data.withdrawals))
                dispatch(setWallets(res.data.wallets))
                dispatch(setInvestments(res.data.investments))
                dispatch(setDepayTransactions(res.data.depay_transactions))

                dispatch(setCards(res.data.cards))
                dispatch(setLoans(res.data.loans))
                dispatch(setShareholders(res.data.shareholders))

            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );

      useEffect(() => {
        getHistory();
      }, []);
 
}

export default AccountHistory
